<template>
  <li class="has-sub">
    <a href="javascript:;">
      <b class="caret pull-right"></b>
      <i class="fa fa-trophy"></i>
      <span>Duel</span>
    </a>
    <ul class="sub-menu">
      <li><router-link to="/register-liga">Register Liga</router-link></li>
      <li><router-link to="/season">Season</router-link></li>
      <li><router-link to="/liga-personal">Liga Personal</router-link></li>
      <li><router-link to="/liga-sekolah">Liga Sekolah</router-link></li>  
    </ul>
  </li>
</template>
<script>
export default {
  name: 'duel-nav'
}
</script>




// WEBPACK FOOTER //
// Navigation.vue?75544e68